import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {RoamingCommunityMemberModel} from "../../models/roaming-community-member.model";
import {UserVerificationService} from "../../services/user-verification.service";
import {Location} from "@angular/common";
import {NgForm} from "@angular/forms";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {KeycloakService} from "../../services/keycloak.service";
import { NgxSelectModule, NgxSelectComponent, INgxSelectOptions } from 'ngx-select-ex';
import {ApiEndpoints} from "../../services/api-endpoints";

declare var $: any;

@Component({ standalone: false, 
  selector: 'app-create-roaming-community-member',
  templateUrl: './create-roaming-community-member.component.html',
})
export class CreateRoamingCommunityMemberComponent implements OnInit {
  public roamingCommunityMemberModel: RoamingCommunityMemberModel;
  public title;
  public rcName;
  public rcId;
  public searchText = '';
  public allNetworks: any[] = [];
  public allNSWithVirtId: any[] = [];
  public showSearch = false;
  public isEnable = false;
  private username: string = KeycloakService.username;
  private value:any = {};

  public selectedOwner(value:any):void {
    this.searchText = value.split(",").splice(0)[0];
    this.isEnable = true;
    for(let nsValue of this.allNSWithVirtId) {
      if(nsValue.name == this.searchText){
        this.roamingCommunityMemberModel.nsId = nsValue.virtId;
      }
    }
  }

  public removed(value:any):void {
    this.isEnable = false;
  }

  @ViewChild('validate') validate: NgForm;

  constructor(private router: Router,
              private route: ActivatedRoute,
              userVerificationService: UserVerificationService,
              private _location: Location,
              private http: HttpClient) {
    this.roamingCommunityMemberModel = new RoamingCommunityMemberModel();
  }

  getAllNSWithSearch(virtId, protocolVersion){
    this.showSearch = true;
    var url = ApiEndpoints.GET_ALL_NETWORK_SERVERS_NO_IRC;
    var body = {
      "virtID" : virtId,
      "protocolVersion": protocolVersion
    };
    const headers = new HttpHeaders({'Content-Type':  'application/json'});
    let options =  {headers: headers};

    this.http.post<Array<any>>(url, body, options).subscribe(
        data => {
          for(let index of data){
            this.allNetworks.push(index.name + ", " + index.netIds.toString());
            this.allNSWithVirtId.push(index);
          }
        });
  }

  save(){
    var body: any = {
      "rcId": this.roamingCommunityMemberModel.communityId,
      "nsId": this.roamingCommunityMemberModel.nsId
    };
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'my-auth-token'
    });
    let options =  {headers: headers};

    var url = ApiEndpoints.CREATE_ROAMING_COMMUNITY_MEMBER;

    this.http.post<any>(url, body, options).subscribe(
        data => {
          this._location.back();
        }
      );
  }

  backClicked() {
    this._location.back();
  }

  ngOnInit() {
    let protocolVersion = this.route.snapshot.queryParams["protocolVersion"];
    this.getAllNSWithSearch(this.route.snapshot.queryParams["rcId"], protocolVersion);
    this.rcName = this.route.snapshot.queryParams["name"];
    this.rcId = this.route.snapshot.queryParams["rcId"].toString();
    this.roamingCommunityMemberModel.communityId = this.route.snapshot.queryParams["rcId"];
    $(document).ready(function () {
      $('.ui.dropdown')
        .dropdown({
          allowAdditions: true
        });
    });
  }
}
